// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"e00f03cb544786b4","5285":"0f7d0cb457ddc011"}[chunkId] + ".css";
};